export default "__VITE_ASSET__HVTgH_ke__"